import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { checkboxStyles, contentSpacingStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

const _seeMoreLessLinkProps = {
    css: css`
        ${getProp("theme.link.defaultProps.css")}
        font-size: ${TYPOGRAPHY.size.smaller};
        font-weight: ${TYPOGRAPHY.weight.bold};
        color: ${COLORS.primary.base};
        margin-top: 1em;
        outline-offset: -${getProp("theme.focus.width")};
        text-decoration: underline;

        &:hover,
        &:focus {
            text-decoration: none;
        }
    `,
};

Object.assign(productListFilterAccordionSectionStyles, {
    accordionSection: {
        panelProps: {
            css: css`
                padding: 0 0 20px;
                border: 0;
            `,
        },
        titleTypographyProps: {
            forwardAs: "h3",
        },
    },
    seeAllLink: _seeMoreLessLinkProps,
    seeLessLink: _seeMoreLessLinkProps,
    checkBoxGroup: {
        css: css`
            ${contentSpacingStyles(".5em", null)}
            color: ${getColor("text.accent")};
        `,
    },
    checkBox: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.base,
        },
    },
    checkBoxSelected: {
        css: css<CheckboxStyleProps>`
            ${checkboxStyles()}
            span[role="checkbox"] {
                border: 2px solid ${COLORS.primary.base} !important;

                svg {
                    stroke: ${COLORS.primary.base} !important;
                }
            }
        `,
        typographyProps: {
            color: COLORS.primary.base,
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.base,
        },
    },
});
